var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDropUp = function SvgArrowDropUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m16.297 13.615-3.694-4.333a.787.787 0 0 0-1.207 0l-3.694 4.333c-.457.538-.088 1.385.605 1.385h7.387c.692 0 1.062-.847.603-1.385Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDropUp);
export default ForwardRef;